/**
 * created by lei lei on 2020/5/28
 */
import React, {Component} from 'react';
import ActivityPending from './ActivityPending';
import {Col, Row} from "antd";
import {Scrollbars} from "react-custom-scrollbars";

export default class ActivityOtherPendingComponents extends Component {
    static defaultProps = {}
    static propTypes = {}

    constructor(props) {
        super(props);
        this.state = {
            num:9
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div className={'ActivityPendingComponents'} style={{width: '100%', padding: 20}}>

                <div style={{background: '#FFFFFF', padding: '18.5px 18.5px 23.5px 18.5px'}}>
                    <div style={{
                        height: 56,
                        lineHeight: '56px',
                        background: 'white',
                        width: '100%',
                        float: 'left',
                        borderBottom: '1px solid #ebebeb'
                    }}>
                        <div style={{fontSize: 16, fontWeight: 'bold', paddingLeft: 20, float: 'left'}}>
                           其他待我处理({this.state.num?this.state.num:0})
                        </div>
                        <div onClick={() => {
                            console.log('点击了函数')
                        }} style={{
                            fontSize: 13,
                            right: 0,
                            color: '#0050B3',
                            float: 'right',
                            marginRight: 20,
                            cursor: 'pointer'
                        }}>查看全部
                        </div>
                    </div>
                    <div style={{clear: 'both'}}/>
                    <div style={{display:'table-row'}}>
                        <div style={{float: 'left'}}>
                            <ActivityPending
                                title={'活动选题标题'}
                                content={'【在线教学深度启示】疫情“大考”下的清华答案'}
                                statusMark={'未领取'}
                                timeMark={'17分钟以前'}
                                showPoint={false}
                                onClickItem={() => {
                                    console.log('点击函数')
                                }}
                            />
                        </div>
                        <div style={{float: 'left'}}>
                            <ActivityPending
                                title={'活动选题标题'}
                                content={'【在线教学深度启示】疫情“大考”下的清华答案'}
                                statusMark={'未领取'}
                                timeMark={'17分钟以前'}
                                showPoint={true}
                                onClickItem={() => {
                                    console.log('点击函数')
                                }}
                            />
                        </div>
                        <div style={{float: 'left'}}>
                            <ActivityPending
                                title={'活动选题标题'}
                                content={'【在线教学深度启示】疫情“大考”下的清华答案'}
                                statusMark={'未领取'}
                                timeMark={'17分钟以前'}
                                showPoint={true}
                                onClickItem={() => {
                                    console.log('点击函数')
                                }}
                            />
                        </div>
                        <div style={{float: 'left'}}>
                            <ActivityPending
                                title={'活动选题标题'}
                                content={'【在线教学深度启示】疫情“大考”下的清华答案'}
                                statusMark={'未领取'}
                                timeMark={'17分钟以前'}
                                showPoint={true}
                                onClickItem={() => {
                                    console.log('点击函数')
                                }}
                            />
                        </div>
                        <div style={{float: 'left'}}>
                            <ActivityPending
                                title={'活动选题标题'}
                                content={'【在线教学深度启示】疫情“大考”下的清华答案'}
                                statusMark={'未领取'}
                                timeMark={'17分钟以前'}
                                showPoint={true}
                                onClickItem={() => {
                                    console.log('点击函数')
                                }}
                            />
                        </div>
                        <div style={{float: 'left'}}>
                            <ActivityPending
                                title={'活动选题标题'}
                                content={'【在线教学深度启示】疫情“大考”下的清华答案'}
                                statusMark={'未领取'}
                                timeMark={'17分钟以前'}
                                showPoint={true}
                                onClickItem={() => {
                                    console.log('点击函数')
                                }}
                            />
                        </div>
                        <div style={{float: 'left'}}>
                            <ActivityPending
                                title={'活动选题标题'}
                                content={'【在线教学深度启示】疫情“大考”下的清华答案'}
                                statusMark={'未领取'}
                                timeMark={'17分钟以前'}
                                showPoint={true}
                                onClickItem={() => {
                                    console.log('点击函数')
                                }}
                            />
                        </div>
                        <div style={{float: 'left'}}>
                            <ActivityPending
                                title={'活动选题标题'}
                                content={'【在线教学深度启示】疫情“大考”下的清华答案'}
                                statusMark={'未领取'}
                                timeMark={'17分钟以前'}
                                showPoint={true}
                                onClickItem={() => {
                                    console.log('点击函数')
                                }}
                            />
                        </div>
                    </div>



                </div>

            </div>
        )
    }

}